<template>
    <div class="result mx-auto">
        <div v-if="products.length>0">
            <h3 class="mt-40 mb-3 text-center">你的預約進度如下：</h3>
            <div>
                <div class="product-item"
                     v-for="(item,index) in products"
                     :key="index">
                    <div class="font-weight-bold product-name">商品名稱：{{item.productName}}</div>
                    <div class="process-container d-flex flex-row">
                        <div class="process-circle">
                            <div class="circle display d-flex align-items-center justify-content-center text-white">
                                <b-icon-check />
                            </div>
                            <div class="circle d-flex align-items-center justify-content-center text-white"
                                 :class="{display: item.isDispatch}">
                                <b-icon-check v-if="item.isDispatch" />
                            </div>
                        </div>
                        <div class="process-title">
                            <div class="title display d-flex justify-content-between align-items-center">
                                <div class="title-text ellipsis">通知業務員中</div>
                                <div class="time px-1">{{item.reserveTimestamp}}</div>
                            </div>
                            <div class="title"
                                 :class="{display: item.isDispatch}">
                                <div class="title-text ellipsis">業務員接獲通知，將與你聯繫</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <h3 class="mt-40 mb-3 text-center">你尚未完成預約, 快來找一個適合你的專家諮詢</h3>
            <div class="d-flex flex-row justify-content-center align-items-center mt-40 pb-5">
                <b-button pill
                          variant="primary"
                          @click="goReserve"
                          data-ga-element="新保險網站_查詢預約_好!我想諮詢"
                          class="global-button">好!我想諮詢</b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { uuid } from 'uuidv4';
import { request } from '@/service';

export default {
    name: 'ResultForShare',
    data() {
        return {
            products: []
        };
    },
    mounted() {
        this.products = JSON.parse(sessionStorage.getItem('products'));
    },
    methods: {
        goHome() {
            const protocol = window.location.protocol;
            const host = window.location.host;

            window.location.href = `${protocol}//${host}${process.env.VUE_APP_HOST}`;
        },
        goReserve() {
            const data = {
                caseId: uuid(),
                srcId: 'FBAG',
                productId: 'NCP',
            };

            request({
                method: 'POST',
                api: '/reserve/api/authenticate',
                data: data
            }).then((res) => {
                this.$cookies.set('token', res.data.jwt);
                const protocol = window.location.protocol;
                const host = window.location.host;
                window.location = `${protocol}//${host}${process.env.VUE_APP_HOST}/reserve`;
            });
        },

    },
};
</script>

<style lang="scss" scoped>
.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.result {
    h3 {
        font-weight: normal;
        font-size: 18px;
        color: #666666;
    }
    .product-item {
        padding: 15px 0;
        border-bottom: 1px solid #dddddd;
        .product-name {
            padding: 0 10px;
        }
        .process-circle {
            width: 20px;
            .circle {
                position: relative;
                width: 20px;
                height: 20px;
                background-color: #ededed;
                border-radius: 50%;
                margin: 18px 10px 20px 10px;
                &::before {
                    position: absolute;
                    z-index: -1;
                    top: -25px;
                    left: 8px;
                    width: 3px;
                    height: 25px;
                    content: '';
                    background-color: #ededed;
                }
                &:first-child::before {
                    content: none;
                }
                &.display::before {
                    background-color: #59c0d0;
                }
                &.display {
                    background-color: #59c0d0;
                }
            }
        }
        .process-title {
            flex: 1;
            .title {
                background-color: #ededed;
                margin: 10px 18px 0 18px;
                padding: 4px 10px;
                color: #999999;
                &.display {
                    background-color: #59c0d0;
                    color: #fff;
                }
                .time {
                    font-size: 14px;
                }
                .title-text {
                    flex: 1;
                }
            }
        }
    }
    .product-item:last-child {
        border: none;
    }
}
</style>
